import { datadogLogs } from '@datadog/browser-logs';
import { LogMetadataProvider } from '@tv2-player/unifiedplayer/src/types/LogMetadataProvider';
import { ServiceContainer } from '@tv2-player/service-container/src/serviceContainer';

export function initDatadogLogs() {
  datadogLogs.init({
    clientToken: 'pube87fbf4d502988b9bd8a41eb0b8e98c1',
    site: 'datadoghq.eu',
    service: 'pwbs.cast',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    version: import.meta.env.VITE_VERSION,
    allowFallbackToLocalStorage: true,
    env: import.meta.env.DEV ? 'dev' : 'prod',
    beforeSend: event => {
      const metadata = ServiceContainer.get(LogMetadataProvider)?.getMetadata();
      event.metadata = metadata;
      return true;
    },
  });
}
